module.exports = __webpack_public_path__ + "smartcard@2x.84472c7f89182d6891b1b96f3efc49db.png";